import React from 'react';

import Fundadores from '../images/backgrounds/header-fundadores.jpg';
import HistoriaMision from '../images/backgrounds/header-historia-mision.jpg';
import Contactenos from '../images/backgrounds/header-contactenos.jpg';
import Sede from '../images/backgrounds/header-sede.jpg';
import VideosInformativos from '../images/backgrounds/header-videos-informativos.jpg';
import Exposiciones from '../images/backgrounds/header-exposiciones.jpg';
import Publicaciones from '../images/backgrounds/header-publicaciones.jpg';
import Reconocimientos from '../images/backgrounds/header-reconocimientos.jpg';
import Investigacion from '../images/backgrounds/header-investigacion.jpg';
import Biblioteca from '../images/biblioteca1.jpg';
import Fototeca from '../images/header-fototeca.jpg';
import Archivos from '../images/archivo-historico1.jpg';
import SearchField from '../components/SearchField';
import Noticias from '../images/archivo-historico1.jpg';

const backgrounds = {
	fundadores: {
		image: Fundadores,
		position: 'center bottom',
	},
	historia: {
		image: HistoriaMision,
		position: 'center 1000%',
	},
	contactenos: {
		image: Contactenos,
		position: 'center bottom',
	},
	sede: {
		image: Sede,
		position: 'center 230%',
	},
	videos: {
		image: VideosInformativos,
		position: 'center 30%',
	},
	exposiciones: {
		image: Exposiciones,
		position: 'center top',
	},
	publicaciones: {
		image: Publicaciones,
		position: 'center bottom',
	},
	reconocimientos: {
		image: Reconocimientos,
		position: 'center 400%',
	},
	investigacion: {
		image: Investigacion,
		position: 'center 150%',
	},
	biblioteca: {
		image: Biblioteca,
		position: 'center 200%',
	},
	fototeca: {
		image: Fototeca,
		position: 'center center',
	},
	archivo: {
		image: Archivos,
		position: 'center center',
	},
	noticias: {
		image: Noticias,
		position: 'center 200%',
	},
};

export default function TopSimpleSection(props) {
	const { children, backgroundImage, search, title, loading } = props;
	if (loading)
		return (
			<section className='c-top-simple-section animated'>
				{search && (
					<div className='c-search-cont'>
						<div className='c-search'>
							<SearchField
								placeholder='¿Qué desea buscar?'
								title={title}
							/>
						</div>
					</div>
				)}
				{children}
			</section>
		);
	return (
		<section
			className='c-top-simple-section '
			style={{
				backgroundImage: `url(${
					backgrounds[backgroundImage]?.image ||
					backgrounds.fundadores?.image
				})`,
				backgroundPosition: backgrounds[backgroundImage]?.position,
			}}>
			{search && (
				<div className='c-search-cont'>
					<div className='c-search'>
						<SearchField
							placeholder='¿Qué desea buscar?'
							title={title}
						/>
					</div>
				</div>
			)}
			{children}
		</section>
	);
}
